import React, { useEffect } from 'react'
import { Button, Drawer, Form } from 'antd'
import { Loader } from '@/components'
import './common-drawer.scss'

export const CommonDrawer = ({
  visible,
  onSubmit,
  onCancel,
  title,
  oktext = 'Save',
  canceltext,
  initialValues,
  formItems,
  loading = false,
  onChangeForm,
  showSubmit = true,
  showCancel = false,
  showDelete = false,
  deletetext = 'Delete',
  onCancelClick,
  onRemoveClick = () => {},
  style = {},
  parentForm = null,
}) => {
  const [form] = parentForm || Form.useForm()
  useEffect(() => {
    form.setFieldsValue(initialValues)
  }, [initialValues])
  return (
    <Drawer
      className="common-drawer"
      open={visible}
      title={title}
      destroyOnClose={true}
      style={style}
      onCancel={onCancel}
      onClose={onCancel}
    >
      <Loader loading={loading}>
        <Form
          form={form}
          className="drawer-form"
          layout="vertical"
          name="form_in_modal"
          initialValues={initialValues}
          onValuesChange={onChangeForm}
          preserve={false}
          requiredMark={false}
          onFinish={onSubmit}
        >
          <div className="form-content">{formItems(form)}</div>
          <div className="footer-container">
            {showDelete && (
              <Button block danger type="primary" onClick={onRemoveClick}>
                {deletetext}
              </Button>
            )}
            {showCancel && (
              <Button block size="large" onClick={onCancelClick || onCancel}>
                {canceltext || 'Cancel'}
              </Button>
            )}
            {showSubmit && (
              <Button block type="primary" size="large" htmlType="submit">
                {oktext}
              </Button>
            )}
          </div>
        </Form>
      </Loader>
    </Drawer>
  )
}
